export const fetchUserEndpoint = () => {
  return '/logged_in_users';
};
